var map = {
	"./BAT-logo.png": 534,
	"./BLUE-logo.png": 236,
	"./BUSD-logo.png": 535,
	"./COMP-logo.png": 536,
	"./CRV-icon.png": 1401,
	"./CRV-logo.jpg": 1402,
	"./CRV-logo.png": 537,
	"./DAI-logo.png": 538,
	"./ERPH0DMWsAEWBjy.jpg": 1403,
	"./ETH-icon.png": 1404,
	"./ETH-logo.png": 539,
	"./FTM-logo.png": 540,
	"./IEARN-icon.png": 1405,
	"./KNC-logo.png": 541,
	"./LEND-logo.png": 542,
	"./LINK-logo.png": 543,
	"./MANA-logo.png": 544,
	"./MKR-logo.png": 545,
	"./REP-logo.png": 546,
	"./SAI-logo.png": 547,
	"./SNX-logo.png": 548,
	"./SUSD-logo.png": 549,
	"./TUSD-logo.png": 334,
	"./USD-logo.png": 550,
	"./USDC-icon.png": 1406,
	"./USDC-logo.png": 551,
	"./USDT-icon.png": 1407,
	"./USDT-logo.png": 552,
	"./WETH-logo.png": 553,
	"./YFI-logo.png": 554,
	"./ZRX-logo.png": 555,
	"./aLINK-logo.png": 556,
	"./aave.png": 1408,
	"./aave.svg": 1409,
	"./alchemy.png": 1410,
	"./bzx.png": 1411,
	"./cUSDC-logo.png": 557,
	"./cUSDT-logo.png": 558,
	"./coinbaseWalletIcon.svg": 580,
	"./compound.png": 1412,
	"./crvBTC-logo.png": 559,
	"./crvBUSD-logo.png": 560,
	"./curvefi.jpg": 1413,
	"./ddex.jpg": 1414,
	"./ddex.png": 1415,
	"./defipulse.png": 1416,
	"./defisnap.svg": 1417,
	"./defizap.png": 1418,
	"./discord.svg": 582,
	"./dydx.jpg": 1419,
	"./dydx.svg": 1420,
	"./ethereum.png": 1421,
	"./etherscan.png": 1422,
	"./fonts/WorkSans-VariableFont_wght.ttf": 336,
	"./fortmaticIcon.png": 575,
	"./github.svg": 583,
	"./iDAI-logo.png": 561,
	"./icn-aethereum.svg": 579,
	"./icn-ledger.svg": 237,
	"./icn-metamask.svg": 335,
	"./kybernetwork.png": 1423,
	"./ledger.png": 1424,
	"./lendf.png": 1425,
	"./lendf.svg": 1426,
	"./medium.svg": 584,
	"./metamask.png": 1427,
	"./metamask.svg": 581,
	"./oCurve-logo.svg": 1428,
	"./oneinch.svg": 1429,
	"./portisIcon.png": 574,
	"./squarelink.png": 576,
	"./synthetix.png": 1430,
	"./telegram.svg": 585,
	"./torus.jpg": 578,
	"./trezor.png": 577,
	"./truffle.png": 1431,
	"./trustWallet.png": 573,
	"./twitter.svg": 586,
	"./uniswap.png": 1432,
	"./uniswap.svg": 1433,
	"./wBTC-icon.png": 1434,
	"./wBTC-logo.png": 562,
	"./walletConnectIcon.svg": 572,
	"./yCRV-logo.jpg": 1435,
	"./yCRV-logo.png": 563,
	"./ycUSDC-logo.png": 564,
	"./ycUSDT-logo.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1400;